export const ASCII_ERROR = "ASCII error";

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    } else {
        const maxDate = new Date();
        maxDate.setTime(maxDate.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 an
        expires = "; expires=" + maxDate.toUTCString();
    }
    document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/";
}

function checkASCIIRegex(str) {
    return /^[\x00-\x7F]*$/.test(str);
}

export function checkASCIICookie() {
    const userName = getCookie('companionName');
    const userEmail = getCookie('companionEmail');
    let isASCII = true;
    if ((userName || userEmail) && (!checkASCIIRegex(userName) || !checkASCIIRegex(userEmail))) {
        setCookie("companionName", userName ?? "");
        setCookie("companionEmail", userEmail ?? "");
        isASCII = false;       
    } 
    return isASCII;
    
}